// Third party
import React from 'react';

// Utils
import { formatMessage } from '@/utils/i18n';
import Comparison from '@/types/comparison';
import { getComparisonTimeSinceSave } from '@/utils/comparison/details';

type ComparisonTopBarNameMobileProps = {
  comparison: Comparison;
};

const ComparisonTopBarNameMobile = ({ comparison }: ComparisonTopBarNameMobileProps) => (
  <div className="comparison-infos flex-row justify-content-center">
    <div className="comparison-name-container d-flex align-items-center justify-content-center">
      <div className="mobile-comparison-name">{comparison.name || formatMessage('Comparison.DefaultName')}</div>
    </div>
    <div className="mobile-comparison-time-since-save-container">
      <span className="comparison-time-since-save">{getComparisonTimeSinceSave(comparison)}</span>
    </div>
  </div>
);

export default ComparisonTopBarNameMobile;
